import { saveStatus, saveStatusComplete } from "@/src/api/tasks"

export const updateStatus = (taskId, params) => {
    return saveStatus(taskId, params);
}

export const updateStatusComplete = (taskId) => {
    return saveStatusComplete(taskId);
}